<div class="wrapper d-flex flex-column">
    <div class="header d-flex row align-items-center">
        <div class="col-md-9">
            <h6 class="px-4 py-3">Catalog Attributes</h6>
        </div>
        <div class="header-action-btn col-md-3 d-flex align-items-center justify-content-end pr-2">
            <button (click)="ngOnInit()" class="margin-right" nz-button nzType="default">Reset</button>

            <button (click)="updateForm()" nz-button nzType="primary">Save</button>
        </div>
    </div>
    <form *ngIf="attributeForm.controls.catalogDesc" [formGroup]="attributeForm">
        <div class="form-container px-4 row g-3">
            <div class="col-md-6 mb-2">
                <label class="form-label"> Catalog Name<span class="text-danger">*</span></label>
                <input maxlength="100" (blur)="trimCatalogDesc()" formControlName="catalogDesc" type="text" class="form-control" placeholder="Enter Catalog Name"
                    required>
                <span class="text-danger"
                    *ngIf=" !attributeForm.get('catalogDesc')?.value && (attributeForm.get('catalogDesc')?.touched || invalidForm)">
                    Catalog Description is required.
                </span>
            </div>




        </div>
        <div class="add-catalog-title">
            <h6>Configuration Options</h6>
        </div>
        <div class="form-container px-4 row g-3">
            <div class="col-md-6">
                <div class="form-check">
                    <input formControlName="allowCloseOut" class="form-check-input" type="checkbox">
                    <label class="form-check-label"> Allow Closeout Lots</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input formControlName="checkCloseOut" class="form-check-input" type="checkbox">
                    <label class="form-check-label">Remove Closeout Lots Automatically</label>
                </div>
            </div>
            <div class="col-md-6 mb-2">
                <label class="form-label"> Minimum Inventory for Removal</label>
                <input maxlength="7" oninput="if (this.value.length > 7) this.value = this.value.slice(0, 7);" formControlName="minimumInventory" type="number" class="form-control" placeholder="Enter Quantity"
                    required>
            </div>
            <div class="col-md-6">
                <label class="form-label"> Email Address for Notification</label>
                <div class="input-group">
                    <input maxlength="200" formControlName="emailAddress" type="text" class="form-control" placeholder="Enter email"
                        required>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input formControlName="notifyOptionalCustomize" class="form-check-input" class="form-check-input"
                        type="checkbox">
                    <label class="form-check-label">Allow Pop-up Notification</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input formControlName="allowAddLettering" class="form-check-input" type="checkbox">
                    <label class="form-check-label">Allow Additional Lettering</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input formControlName="allowKeywordSearch" class="form-check-input" type="checkbox">
                    <label class="form-check-label"> Allow Keyword Search</label>
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-check">
                    <input formControlName="multiLotUpdate" class="form-check-input" type="checkbox">
                    <label class="form-check-label"> Enable multi-category Product update</label>
                </div>
            </div>



        </div>
        <div class="form-container px-4 row g-3 py-0">
            <div class="ship-title">
                <h6>Ship-to Address Pop-up</h6>
            </div>
            <nz-radio-group class="mt-0 mb-2" formControlName="shipToAddrPopUp">
                <label nz-radio [nzValue]=0>None</label>
                <label nz-radio [nzValue]=1>Verify ship-to address, change allowed</label>
                <label nz-radio [nzValue]=2>Verify ship-to address, no change allowed</label>
                <label nz-radio [nzValue]=3>
                    Verify ship-to address, add text
                </label>
            </nz-radio-group>
            <div class="mt-3">
                <textarea maxlength="250" formControlName="checkoutMsg" type="text" class="form-control"></textarea>
            </div>
        </div>
        <div class="mt-4 mb-3 d-flex justify-content-end pr-2">
            <button (click)="ngOnInit()" class="margin-right" nz-button nzType="default">Reset</button>

            <button (click)="updateForm()" nz-button nzType="primary">Update</button>
        </div>
    </form>
</div>